import qs from 'qs';

import { axios } from 'lib';

export const getCompanies = async (type, searchTerm = '', includeInactive = true, includeShadow = true) => {
  const queryStringParams = qs.stringify({
    offset: 0,
    limit: 10,
    search: searchTerm,
    companytype: type,
    includeinactive: includeInactive,
    includeshadow: includeShadow,
  });

  const { data } = await axios.get(`/api/companies?${queryStringParams}`);
  console.log(data);

  return data;
};
